import React from 'react'
import { Card, CardBody, Col, Row } from 'reactstrap'
import SubmittersMessage from 'views/shared/SubmittersMessage'

const Dashboard = () => {
  return (
    <div className="content">
      <Row>
        <Col>
          <Card className="card-subcategories">
            <CardBody>
              <SubmittersMessage />
            </CardBody>
          </Card>
        </Col>
      </Row>
      <Row>
        <Col className="ml-auto mr-auto" xs={12}>
          <Card>
            <CardBody>
              <h6 className="text-info">
                <a
                  href="https://listserv2.cdph.ca.gov/scripts/wa.exe?SUBED1=CDPHWICVENDORS&A=1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sign up to receive important regulatory notices regarding the
                  California WIC program.
                </a>
              </h6>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default Dashboard
